import { ViewChild, Component, EventEmitter, Input, Output } from "@angular/core";

// Angular Material
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";

// Rxjs
import { Observable } from "rxjs";
import { state, style, trigger } from '@angular/animations';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { User, UserDTO } from '../../../commons/models/user.model';
import { Tenants } from "../../../commons/models/tenants";


export type UsersColumn = "name" | "email" | "phone" | "role" | "tenant" | "actions";

@Component({
  selector: "app-users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", display: "none" })
      ),
      state("expanded", style({ height: "*" })),
    ]),
  ],
})
export class UsersListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() users: User[];
  @Input() selectedUsers: User[];
  @Input() defaultFilters: any;
  @Input() tenants: Tenants[];

  @Input() total: Observable<number>;
  @Input() displayedColumns = ["name", "email", "phone", "role", "tenant", "actions"];

  @Input() canAdd: boolean;
  @Input() canEdit: boolean;
  @Input() canSelect: boolean;

  @Output() onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output() onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() onSelectUser: EventEmitter<User> = new EventEmitter<User>();
  @Output() onAddUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEditUser: EventEmitter<User> = new EventEmitter<User>();
  @Output() onShowUser: EventEmitter<User> = new EventEmitter<User>();
  @Output() onAddSelectedUser: EventEmitter<User> = new EventEmitter<User>();
  @Output() onRemoveSelectedUser: EventEmitter<User> = new EventEmitter<User>();
  @Output() onUpdateTenant: EventEmitter<{ user: User, tenantId: number }> = new EventEmitter<{ user: User, tenantId: number }>();

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  expandedElement: User | null;

  constructor() {}

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe((sort) => {
        this.onSortChange.emit(sort);
      });
    }

    if (this.paginator) {
      this.paginator.page.subscribe((pageEvent) => {
        this.onPageChange.emit(pageEvent);
      });
    }
  }


  isSelected(user: User): boolean {
    return this.selectedUsers.map(obj => obj.email).includes(user.email);
  }

  addUser() {
    this.onAddUser.emit();
  }

  addSelectedUser(user: User) {
    this.onAddSelectedUser.emit(user);
  }

  removeSelectedUser(user: User) {
    this.onRemoveSelectedUser.emit(user);
  }

  editUser(user: User) {
    this.onEditUser.emit(user);
  }

  selectUser(user: User) {
    this.onSelectUser.emit(user);
  }

  onFilter(filters: any) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
  }

  showUser(user: User) {
    this.onShowUser.emit(user);
  }

  updateTenant(user: User, tenantId: number) {
    this.onUpdateTenant.emit({ user, tenantId });
  }

  isAllSelected() {
    const numSelected = this.selectedUsers.length;
    const numRows = this.users.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selectedUsers.forEach(user => this.removeSelectedUser(user))
      : this.users.forEach(user => this.addSelectedUser(user));
  }

  getTenantsList(user: User): string {
    if (!user.tenants || user.tenants.length === 0) {
      return 'N/A';
    }
    return user.tenants.map(t => t.name).join(', ');
  }

}
